/**
 * @author Fernando Ruano
 * @file index.js
 * @description Patient Profile Container
 */

// Dependencies
import React from 'react';

// Components
import AppRoutes from '@nephro/components/AppRoutes';
import AppCardLayout from '@nephro/components/AppCardLayout';

// Routes
import routes from './routes';

/**
 * Patient Profile Container.
 * @return { Node } React Patient Profile container.
 */
const PatientProfileContainer = () => {
  return (
    <AppCardLayout>
      <AppRoutes routes={routes} />
    </AppCardLayout>
  );
};

/**
 * @name PatientProfile.propTypes
 * @type { Object }
 */
PatientProfileContainer.propTypes = {};

/**
 * Default props
 */
PatientProfileContainer.defaultProps = {};

export default PatientProfileContainer;
